import { vnTemplate } from '../../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate';
import { renderKoDataTable, renderKoEmptyState } from '~/components/templates/listPageDataTable';
import { renderRecruitingTextCell } from '~/components/templates/recruiting/RecruitingTable';
import { html, LpButton, LpEditCard, LpEditGrid, LpEditPage, LpFormField, LpPageHeader, LpTable, raw } from '~/design-system';
export class adminTransmissionGroupEdit_template extends vnTemplate {
    /**
     * Return the template key used by the Valnet template framework.
     *
     * @return string
     */
    getTemplateName() {
        return 'adminTransmissionGroupEdit-template';
    }
    /**
     * Return the CSS classes applied to the template root element.
     *
     * @return Array<string>
     */
    getMainElementClasses() {
        return ['w-content'];
    }
    /**
     * Build the Knockout view model used by this template.
     *
     * @return any
     */
    buildViewModel() {
        const self = this;
        return {
            id: ko.observable(0),
            label: ko.observable(''),
            description: ko.observable(''),
            transmissions: ko.observableArray([]),
            onClickSave: function () { self.caller.saveGroup(); },
            onClickRun: function () { self.caller.runScheduled(); },
            onClickBack: function () { self.caller.backToGroups(); },
            onClickTransmission: function (row) { self.caller.editTransmission(row.id); },
        };
    }
    /**
     * Return the HTML markup for this template.
     *
     * @return string
     */
    getTemplateHtml() {
        return `
            ${LpPageHeader({
            title: html `<span data-bind="text: id() ? 'Edit Transmission Group' : 'New Transmission Group'"></span>`,
            description: 'Define the label, description, and scheduled transmissions for this group.',
            icon: 'stack',
            actions: html `
                    ${LpButton({
                label: 'Back',
                prefixIcon: 'arrow-left',
                size: 'base',
                variant: 'secondary',
                attributes: {
                    'data-bind': 'click: onClickBack',
                },
            })}
                    ${LpButton({
                label: 'Run All Scheduled Tasks',
                prefixIcon: 'play',
                size: 'base',
                variant: 'secondary',
                attributes: {
                    'data-bind': 'visible: id, click: onClickRun',
                },
            })}
                    ${LpButton({
                label: 'Save',
                prefixIcon: 'check',
                size: 'base',
                variant: 'primary',
                attributes: {
                    'data-bind': 'click: onClickSave',
                },
            })}
                `,
        })}

            ${LpEditPage({
            children: html `
                    ${LpEditCard({
                title: 'Group Summary',
                description: 'Define the label and description for this transmission group.',
                children: LpEditGrid({
                    children: html `
                                ${LpFormField({
                        label: 'Label',
                        children: raw('<input class="edit-input" type="text" placeholder="Group label" data-bind="value: label" />'),
                    })}
                                ${LpFormField({
                        label: 'Description',
                        className: 'edit-span',
                        children: raw('<textarea class="edit-input edit-textarea" rows="4" placeholder="Describe what this group schedules" data-bind="value: description"></textarea>'),
                    })}
                            `,
                }),
            })}

                    ${LpEditCard({
                title: 'Transmissions in Group',
                description: 'Open a transmission to review or edit its configuration.',
                attributes: {
                    'data-bind': 'visible: id',
                },
                children: raw(this.getTransmissionsTableHtml()),
            })}
                `,
        })}
        `;
    }
    getTransmissionsTableHtml() {
        const columns = this.getTransmissionTableColumns();
        return renderKoDataTable({
            title: 'Transmissions in Group',
            caption: 'Transmissions assigned to this scheduling group',
            columns,
            className: 'transmission-group-edit-table',
            children: this.getTransmissionsTableBodyHtml(columns),
        });
    }
    getTransmissionTableColumns() {
        return [
            {
                key: 'id',
                label: 'ID',
                resizable: true,
                width: 88,
                minWidth: 72,
            },
            {
                key: 'name',
                label: 'Name',
                resizable: true,
                minWidth: 220,
            },
            {
                key: 'transmissionType',
                label: 'Type',
                resizable: true,
                width: 180,
                minWidth: 144,
            },
            {
                key: 'channel',
                label: 'Channel',
                resizable: true,
                width: 140,
                minWidth: 112,
            },
            {
                key: 'actions',
                label: 'Actions',
                align: 'end',
                width: 112,
                minWidth: 104,
                required: true,
            },
        ];
    }
    getTransmissionsTableBodyHtml(columns) {
        return html `
            ${LpTable.Body({
            attributes: {
                'data-bind': 'foreach: transmissions',
            },
            children: LpTable.Row({
                children: html `
                        ${renderRecruitingTextCell({ column: columns[0], binding: 'id', className: 'transmission-group-edit-table__id' })}
                        ${renderRecruitingTextCell({ column: columns[1], binding: 'name' })}
                        ${renderRecruitingTextCell({ column: columns[2], binding: 'transmissionType' })}
                        ${renderRecruitingTextCell({ column: columns[3], binding: 'channel' })}
                        ${LpTable.Cell({
                    column: columns[4],
                    className: 'transmission-group-edit-table__actions',
                    children: html `
                                ${LpButton({
                        label: 'Open',
                        prefixIcon: 'pencil-simple',
                        size: 'sm',
                        variant: 'secondary',
                        attributes: {
                            'data-bind': 'click: $parent.onClickTransmission',
                        },
                    })}
                            `,
                })}
                    `,
            }),
        })}
            ${renderKoEmptyState({
            colSpan: columns.length,
            visibleBinding: 'transmissions().length === 0',
            title: 'No transmissions assigned',
            description: 'This group does not have any transmissions assigned yet.',
            icon: 'paper-plane-tilt',
        })}
        `;
    }
    /**
     * Apply a transmission group DTO to the edit view model.
     *
     * @param group any
     * @return void
     */
    setGroup(group) {
        const vm = this.getTemplateViewModel();
        vm.id(Number(group.id || 0));
        vm.label(group.label || '');
        vm.description(group.description || '');
        vm.transmissions(group.transmissions || []);
    }
    /**
     * Build the save payload from the current view model state.
     *
     * @return any
     */
    getPayload() {
        const vm = this.getTemplateViewModel();
        return {
            id: Number(vm.id() || 0),
            label: vm.label(),
            description: vm.description(),
        };
    }
}
